var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Avatar } from '../avatar';
/** @deprecated Will be removed in `v6` - use `decor` on `Card.Header` with `Card.Avatar` instead. */
function HeadstoneAvatar(_a) {
    var { content } = _a, restProps = __rest(_a, ["content"]);
    return (_jsx(Avatar, Object.assign({ content: content, size: "medium", variant: "base" }, restProps)));
}
export default HeadstoneAvatar;
